{% block prems_discount_category_detail_discount %}
    <div>
        {# Discount value and type card #}
        {% block prems_discount_category_discountValueAndType %}
        <mt-card
            :title="$tc('prems-discount-category.detail.card.discountValueAndType.title')"
            :isLoading="isLoading"
        >
            <sw-container
                columns="1fr 1fr"
                gap="0px 30px"
            >
                {# Discount type field #}
                    {% block prems_discount_category_detail_content_discountValueAndType_discount_type_field %}
                <sw-single-select
                    v-model:value="discountCategory.type"
                    :label="$tc('prems-discount-category.detail.card.discountValueAndType.field.discountTypeLabel')"
                    :placeholder="$tc('prems-discount-category.detail.card.discountValueAndType.field.discountTypePlaceholder')"
                    :options="discountTypeOptions"
                >
                        </sw-single-select>
                {% endblock %}

                    {# Discount field #}
                    {% block prems_discount_category_detail_content_discountValueAndType_discount_field %}
                <mt-number-field
                    v-model="discountCategory.discount"
                    v-if="discountCategory.type === '0'"
                    :label="$tc('prems-discount-category.detail.card.discountValueAndType.field.discountType.relative')"
                    :placeholder="$tc('prems-discount-category.detail.card.discountValueAndType.field.discountPlaceholder')"
                    :min="0"
                    :max="100"
                >
                    <template #suffix>%</template>
                </mt-number-field>
                <mt-number-field
                    v-model="discountCategory.discount"
                    v-else
                    :digits="2"
                    :label="$tc('prems-discount-category.detail.card.discountValueAndType.field.discountType.absolute')"
                    :placeholder="$tc('prems-discount-category.detail.card.discountValueAndType.field.discountPlaceholder')"
                >
                    <template #suffix>€</template>
                </mt-number-field>
                {% endblock %}

                    {# Upprice option field #}
                    {% block prems_discount_category_detail_content_discountValueAndType_discount_upprice_option_field %}
                <sw-single-select
                    v-model:value="discountCategory.isUpprice"
                    :label="$tc('prems-discount-category.detail.card.discountValueAndType.field.discountOrUppriceLabel')"
                    :options="discountOrUppriceOptions"
                >
                        </sw-single-select>
                {% endblock %}

                {# Price rounding #}
                {% block prems_discount_category_detail_content_discountValueAndType_discount_price_rounding_field %}
                    <sw-single-select
                        v-model:value="discountCategory.priceRounding"
                        :label="$tc('prems-discount-category.detail.card.discountValueAndType.field.priceRoundingLabel')"
                        :options="priceRoundingOptions">
                    </sw-single-select>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}

        {# Discount display #}
        {% block prems_discount_category_display_discount %}
        <mt-card
            :title="$tc('prems-discount-category.detail.card.displayDiscount.title')"
            :isLoading="isLoading"
        >
            <sw-container
                columns="1fr 1fr"
                gap="0px 30px"
            >
                {# Discount detail page config #}
                    {% block prems_discount_category_detail_content_display_discount_detail_page_field %}
                <sw-single-select
                    v-model:value="discountCategory.displayTypeDiscountOnDetailPage"
                    :label="$tc('prems-discount-category.detail.card.displayDiscount.detailPageLabel')"
                    :options="discountDisplayTypeOptions"
                >
                        </sw-single-select>
                {% endblock %}

                    {# Discount listing page config #}
                    {% block prems_discount_category_detail_content_display_discount_listing_page_field %}
                <sw-single-select
                    v-model:value="discountCategory.displayTypeDiscountOnListingPage"
                    :label="$tc('prems-discount-category.detail.card.displayDiscount.listingPageLabel')"
                    :options="discountDisplayTypeOptions"
                >
                        </sw-single-select>
                {% endblock %}
            </sw-container>
        </mt-card>
        {% endblock %}
    </div>
{% endblock %}